import DndInterface from '@components/testDndKit/dndInterface';
import type { DndKitValue, NormalSourceData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  sourceData: Maybe<NormalSourceData>;
  onDataChange: (data: NormalSourceData) => void;
};

export const StaticSelector = observer(
  ({ sourceData, onDataChange }: Props) => {
    const updateValues = (newValues: DndKitValue[]) => {
      onDataChange({ values: newValues });
    };

    const addValue = (valueToAdd: DndKitValue) => {
      if (!sourceData) {
        onDataChange({ values: [valueToAdd] });
        return;
      }
      const newValues = [...sourceData.values, valueToAdd];
      onDataChange({ values: newValues });
    };

    return (
      <DndInterface
        addValue={addValue}
        title="Values"
        updateValues={updateValues}
        values={sourceData?.values ?? []}
      />
    );
  }
);
